
type column = {
    prop: String;
    label: String;
    width: Number;
};

type dialogSelect = {
    project_type_pid?: number;
    search?: string;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
const partsSaleColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 120,
    },
    {
        prop: "sale_number",
        label: "数量",
        width: 80,
    },
    {
        prop: "sale_price",
        label: "单价",
        width: 80,
    },
    {
        prop: "total_price",
        label: "金额",
        width: 80,
    },
];

interface myParts {
    parts_id: string,
    sale_price: string,
    sale_number: string
};

interface addModel {
    partsSale_id: number,
    partsSale_date: string,
    partsSale_admin_id: string,
    partsSale_name: string,
    partsSale_phone: string,
    partsSale_desc: string,
    partsList: Array<any>,
    parts: Array<any>
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "bill_time_text",
        label: "单据日期",
        width: 75,
    },
    {
        prop: "partsSale_settement_time_text",
        label: "结算时间",
        width: 75,
    },
    {
        prop: "toexamine",
        label: "状态",
        width: 75,
    },
    {
        prop: "sale_name",
        label: "销售员",
        width: 75,
    },
    {
        prop: "partsSale_name",
        label: "客户姓名",
        width: 75,
    },
    {
        prop: "partsSale_phone",
        label: "客户手机",
        width: 75,
    },
    {
        prop: "sale_number",
        label: "数量",
        width: 75,
    },
    {
        prop: "sale_price",
        label: "金额",
        width: 75,
    },
    {
        prop: "partsSale_settement_price",
        label: "待回款",
        width: 75,
    },
    {
        prop: "partsSale_desc",
        label: "备注",
        width: 75,
    },
];

const addFormRules = {
    partsSale_admin_id: [{required: true, message: '必填', trigger: 'change'}],
    partsSale_name: [{required: true, message: '必填', trigger: 'change'}],
}

const partsColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 84,
    },
    
    {
        prop: "specification",
        label: "规格",
        width: 84,
    },
    {
        prop: "mountings_type_name",
        label: "配件分类",
        width: 84,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 84,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 84,
    },
    {
        prop: "price",
        label: "价格",
        width: 84,
    },
    {
        prop: "stock",
        label: "库存",
        width: 84,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList,
    getOrderCarMountings,
    getOrderCarProject,
    getPartsSaleAdd,
    getLibraryInfo,
    getPartsSaleInfo,
    permissionList,
    getPartsSaleEdit,
    getPartsSaleUpState,
    getCollectionType,
    getPartsSaleSettlementInfo,
    getPartsSaleSettlement,
    getPartsSaleBadDebt,
    getPayQrcode,
    getOrderCarOrderinfo
} from "@/api/http";


import editList from "@/components/editlist/editlist.vue";
import {Request} from '@/api/request';
import {validateInput, validateClass} from "@/assets/js/formRules";
import {partsFormType} from "@/assets/types/common";
import {useRoute, useRouter} from 'vue-router'

export default defineComponent({
    name: "pickingInfo",
    components: {editList},
    setup(props, {attrs, slots, emit}) {
        const setTitle: any = inject("setTitle");
        setTitle(['配件销售']);
        
        const headClass = inject("headClass");
        let userInfo = ref({} as any);
        let settleData = reactive({
                settle_show: false,
                settle_load: false,
                order_sn: "",
                customer_name: "",
                customer_phone: "",
                sale_price: "",
                settle_price: "",
                partsSale_settement_price:"",
                settleForm: {
                    partsSale_id:null,
                    payment: null,
                    price: "",
                },
                collection: []
            }),
            getCollectionTypeList = (() => {
                getCollectionType({}).then((res: any) => {
                    settleData.collection = res?.content?.list;
                });
            });
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            loading = ref(true),
            type = ref(''),
            route: any = useRoute(),
            Router: any = useRouter(),
            partsTable = ref([]),
            detailTable = ref([] as Array<any>),
            isMountings = ref(false),
            add_dialog_title = ref(""),
            purchaseDetail = ref({}),
            roleList = ref({} as any),
            dialogSelect = ref({} as dialogSelect),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search: ''
            }),
            selectList = ref({
                branch: [],
                staff: []
            }),
    
            isPrint = ref(false),
            publicImgeUrl = ref(''),
            orderDetail = ref({} as any),
            
            remote_loading = ref(false),
            screenParameter = ref({
                time_type: '1',
                start_time: null,
                end_time: null,
                search: '',
                status: '',
                page: currentPage.value,
                pagesize: pageSize.value,
                date_array: [],
                onaccount: '',
                partsSale_admin_id: '',
            } as any),
            partsDia_show = ref(false),
            partsSaleDia_show = ref(false),
            add_dialog = ref(false),
            addFormRef = ref(null) as any,
            getFirstNowLastDay = (): string => {
                let now = new Date();
                let strLink = "-";
                let year = now.getFullYear();
                let month: any = now.getMonth() + 1;
                let day: any = now.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 1 && day <= 9) {
                    day = "0" + day;
                }
                let firstDate: string = year + strLink + month + strLink + '01';
                let currentDate = year + strLink + month + strLink + day;
                //var lastDay = this.getLastDay(year, month);
                //var lastDate = year + strLink + month + strLink + lastDay;
                return currentDate;
            },
            addForm = reactive<addModel>({
                partsSale_id: 0,
                partsSale_date: getFirstNowLastDay(),
                partsSale_admin_id: '',
                partsSale_name: '',
                partsSale_phone: '',
                partsSale_desc: '',
                partsList: [],
                parts: [],
            }),
            dialogTitle = ref("新增配件"),
            formRef = ref(null),
            form = ref({
                mountings_name: '',
                mountings_id: '',
                mountings_stock: ''
            } as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            // 打印的表单
            printData = {
                id: "#print",
                popTitle: "配件销售单",
                startCallback() {
                },
            },
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                cost_price: [{required: true, message: '必填', trigger: "change"}],
                mountings_type_pid: [{required: true, message: '必填', trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            //修改
            editClick = (partsSale_id: any) => {
                add_dialog.value = true;
                add_dialog_title.value = "修改销售单";
                getPartsSaleInfo({partsSale_id}).then((res: any) => {
                    if (res.status == 200) {
                        addForm.partsSale_id = partsSale_id;
                        addForm.partsSale_date = res.content.list.bill_time_text;
                        addForm.partsSale_admin_id = res.content.list.partsSale_admin_id;
                        addForm.partsSale_name = res.content.list.partsSale_name;
                        addForm.partsSale_phone = res.content.list.partsSale_phone;
                        addForm.partsSale_desc = res.content.list.partsSale_desc;
                        addForm.partsList = res.content.list.data_list;
                    }
                });
                
            },
            //作废
            invalidClick = ((partsSale_id: any) => {
                getPartsSaleUpState({partsSale_id, status: 2}).then((res: any) => {
                    getTableData();
                });
            }),
            //反审核
            backToExamineClick = ((partsSale_id: any) => {
                getPartsSaleUpState({partsSale_id, status: 0}).then((res: any) => {
                    getTableData();
                });
            }),
            //恢复
            recoveryClick = ((partsSale_id: any) => {
                getPartsSaleUpState({partsSale_id, status: 0}).then((res: any) => {
                    getTableData();
                });
            }),
            //审核
            checkClick = ((partsSale_id: any) => {
                getPartsSaleUpState({partsSale_id, status: 1}).then((res: any) => {
                    getTableData();
                });
            }),
            //点击结算
            settlementClick = ((partsSale_id: any) => {
                settleData.settle_show = true;
                settleData.settle_load = false;
                getPartsSaleSettlementInfo({partsSale_id}).then((res: any) => {
                    settleData.order_sn = res.content.list.partsSale_ordersn;
                    settleData.customer_name = res.content.list.partsSale_name;
                    settleData.customer_phone = res.content.list.partsSale_phone;
                    settleData.sale_price = res.content.list.sale_price;
                    settleData.settle_price = res.content.list.settlement_price;
                    settleData.settleForm.price = res.content.list.sale_price;
                    settleData.settleForm.partsSale_id = res.content.list.partsSale_id;
                });
            }),
            //回款
            returnPriceClick = ((partsSale_id: any)=>{
                settleData.settle_show = true;
                settleData.settle_load = false;
                getPartsSaleSettlementInfo({partsSale_id}).then((res: any) => {
                    settleData.order_sn = res.content.list.partsSale_ordersn;
                    settleData.customer_name = res.content.list.partsSale_name;
                    settleData.customer_phone = res.content.list.partsSale_phone;
                    settleData.sale_price = res.content.list.sale_price;
                    settleData.settle_price = res.content.list.settlement_price;
                    settleData.settleForm.price = res.content.list.partsSale_settement_price;
                    settleData.settleForm.partsSale_id = res.content.list.partsSale_id;
                    settleData.partsSale_settement_price = res.content.list.partsSale_settement_price;
                });
            }),
            //坏账
            badDebtClick = ((partsSale_id: any)=>{
                getPartsSaleBadDebt({partsSale_id}).then(()=>{
                
                });
            }),
            addClick = () => {
                add_dialog_title.value = "新增销售单";
                addForm.partsSale_date = getFirstNowLastDay();
                addForm.partsSale_admin_id = '';
                addForm.partsSale_name = '';
                addForm.partsSale_phone = '';
                addForm.partsSale_desc = '';
                addForm.partsList = [];
                addForm.parts = [];
                addForm.partsSale_id = 0;
                add_dialog.value = true;
                (addFormRef.value as any).resetFields();
            },
            _defItem = (index: number) => {
                if (!confirm('是否确认操作？')) return
                addForm.partsList.splice(index, 1);
            },
            //点击添加出现配件列表
            _editlist_add = () => {
                getOrderCarMountings({...dialogSelect.value, limit: 1}).then((res: any) => {
                    partsTable.value = res?.content?.mountings_data?.list || [];
                    partsDia_show.value = true;
                });
            },
            dialogSelectChange = () => {
                getOrderCarMountings(dialogSelect.value).then((res: any) => {
                    partsTable.value = res?.content?.mountings_data?.list || [];
                });
            },
            // 点击单据编号触发
            bindPurchaseInfo = (partsSale_id: number) => {
                getPartsSaleInfo({partsSale_id}).then((res: any) => {
                    if (res.status == 200) {
                        let info = res.content.list;
                        let arr = [[
                            '单据编号',
                            info.partsSale_ordersn,
                            '状态',
                            info.toexamine,
                            '单据日期',
                            info.bill_time_text,
                            '销售员',
                            info.sale_name,
                        ], [
                            '制单时间',
                            info.create_time_text,
                            '制单人',
                            info.admin,
                            '结算时间',
                            info.partsSale_settement_time_text,
                            '结算人',
                            info.partsSale_settement_id_text,
                        ], [
                            '销售金额',
                            info.sale_price,
                            '销售数量',
                            info.sale_number,
                            '客户姓名',
                            info.partsSale_name,
                            '客户手机',
                            info.partsSale_phone,
                        ], [
                            '备注',
                            info.partsSale_desc,
                        ]];
                        detailTable.value = arr;
                        purchaseDetail.value = res.content.list;
                        partsSaleDia_show.value = true;
                        if (res.content.list.data_list.length > 0) {
                            isMountings.value = true
                        }
                    }
                });
                
            },
            partsCurrentChange = (selection: any): void => {
                if (!selection) return
                addForm.partsList.push({
                    parts_id: selection.id,
                    sale_price: selection.price,
                    name: selection.name,
                    specification: selection.specification,
                    mountings_type_name: selection.mountings_type_name,
                    mountings_brand_name: selection.mountings_brand_name,
                    unit: selection.mountings_unit_name,
                    sale_number: '0'
                })
                partsDia_show.value = false;
            },
            partsSelectionChange = () => {
            
            },
            getTableData = (): void => {
                loading.value = true;
                let data = {
                    type: 1,
                    role_name: 'parts_sale',
                }
                permissionList(data).then((res: any) => {
                    roleList.value = res?.content?.list || 0;
                });
                let start_time = screenParameter.value.date_array ? screenParameter.value.date_array[0] / 1000 : "";
                let end_time = screenParameter.value.date_array ? screenParameter.value.date_array[1] / 1000 : "";
                // let start_time = screenParameter.date_array?screenParameter.date_array[0]/1000:"";
                // let end_time = screenParameter.date_array ?screenParameter.date_array[1]/1000:"";
                Request.axiosInstance({
                    url: '/adminapi/PartsSale/list',
                    data: {
                        ...screenParameter.value,
                        page: currentPage.value,
                        pagesize: pageSize.value,
                        start_time: start_time,
                        end_time: end_time
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    
                })
                
            },
            
            saveClick = () => {
                // attrs[addFormRef].validator(valid => {
                //
                // });
                (addFormRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        //if (Number(addForm.value.))
                        if (addForm.partsSale_id > 0) {//修改
                            getPartsSaleEdit(addForm).then((res: any) => {
                                add_dialog.value = false;
                                getTableData();
                            });
                        } else {//新增
                            getPartsSaleAdd(addForm).then((res: any) => {
                                add_dialog.value = false;
                                getTableData();
                            });
                        }
                        
                    }
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({search: e});
            },
            formSelectChange = (e: number) => {
                getSelectData({type_pid: e});
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            screenChange = (e: any): void => {
                getTableData();
            },
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    let data: any = {...form.value, id: 0};
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({type_pid: form.value.mountings_type_pid});
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            //结算
            _submitForm = (): void => {
                if (!settleData.settleForm.payment) {
                    confirm("请选择支付方式");
                    return
                }
                if (Number(settleData.settleForm.price)<0) {
                    confirm("请输入大于等于零的金额");
                    return
                }
                settleData.settle_load = true;
                getPartsSaleSettlement({...settleData.settleForm}).then(()=>{
                    settleData.settle_show = false;
                    settleData.settle_load = false;
                    getTableData();
                });
            },
            
            _option = (url: string, data: any) => {
                Router.push({
                    path: url,
                    query: data
                })
            },
            // 触发打印
            bindPrint = (partsSale_id: number): void => {
                // 获取支付二维码
                // getPayQrcode({order_id}).then((res: any) => {
                //     if (res.status == 200) {
                //         publicImgeUrl.value = res.content.gong_image;
                //     }
                // });
                // 列表打印按钮是没有请求订单信息的，需要单独请求
                getPartsSaleInfo({partsSale_id}).then((res: any) => {
                    if (res.status == 200) {
                        if (res.content.list) {
                            orderDetail.value = res.content.list;
                            publicImgeUrl.value = res.content.list.gong_image;
                            document.getElementById("printBtn")!.click();
                            isPrint.value = true;
                            setTimeout(() => {
                                isPrint.value = false;
                                console.log(isPrint.value)
                            }, 1)
                        }
                    }
                });
            },
            _purchaseMarkin = (id: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/purchaseMarkin',
                    data: {purchase_id: id}
                }).then((res: any) => {
                    getTableData()
                })
            }
        onMounted(() => {
            let user_info = localStorage.getItem('user_info')
            if(user_info){
                userInfo.value = JSON.parse(user_info)
            }
            getCollectionTypeList();
            
            //total.value = 0;
            //currentPage.value = 0;
            //pageSize.value = 10;
            
            
            //screenParameter.value['start_time'] = new Date()
            //screenParameter.value['end_time'] = new Date()
            //screenParameter.value['time'] = [new Date(), new Date()]
            
            
            Request.axiosInstance({
                url: 'adminapi/OrderCar/constructors',
                data: {status: 1}
            }).then((res: any) => {
                selectList.value.branch = res?.content?.branch
                selectList.value.staff = res?.content?.staff
            })
            
            getTableData();
            
            
        });
        
        
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            selectList,
            remote_loading,
            dialogTitle,
            userInfo,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            _submitForm,
            type,
            _option,
            _purchaseMarkin,
            screenParameter,
            screenChange,
            add_dialog,
            addFormRules,
            addFormRef,
            addForm,
            addClick,
            _editlist_add,
            partsDia_show,
            dialogSelectChange,
            partsTable,
            partsCurrentChange,
            partsSelectionChange,
            partsColumn,
            _defItem,
            saveClick,
            detailTable,
            isMountings,
            bindPurchaseInfo,
            purchaseDetail,
            partsSaleDia_show,
            partsSaleColumn,
            roleList,
            dialogSelect,
            editClick,
            add_dialog_title,
            invalidClick,
            backToExamineClick,
            recoveryClick,
            checkClick,
            settleData,
            getCollectionTypeList,
            settlementClick,
            returnPriceClick,
            badDebtClick,
            bindPrint,
            isPrint,
            orderDetail,
            printData,
            publicImgeUrl
        };
    },
});
